import React, {
  forwardRef,
  useImperativeHandle,
  ForwardRefRenderFunction,
  useState,
  useCallback,
} from "react";
import { useTranslation } from "react-i18next";

import Modal from "../Modal";

import useStyles from "./styles";

export interface RemoveItemsFromLocationHandles {
  openModal: (locationId: string | number) => void;
  closeModal: () => void;
}

type Props = {
  onDecline: () => void;
  onAccept: (locationId: string | number) => void;
};

const RemoveItemsFromLocationModal: ForwardRefRenderFunction<
  RemoveItemsFromLocationHandles,
  Props
> = (props, ref) => {
  const { onAccept, onDecline } = props;

  const { t: translate } = useTranslation();
  const classes = useStyles();

  const [visible, setVisible] = useState(false);
  const [locationId, setLocationId] = useState<string | number>("");

  const openModal = useCallback((_locationId: string | number) => {
    setLocationId(_locationId);
    setVisible(true);
  }, []);
  const closeModal = useCallback(() => {
    setLocationId("");
    setVisible(false);
  }, []);

  useImperativeHandle(ref, () => {
    return {
      openModal,
      closeModal,
    };
  });

  const onNoPress = useCallback(() => {
    onDecline();
    closeModal();
  }, []);

  const onYesPress = useCallback(() => {
    onAccept(locationId);
    closeModal();
  }, [locationId, closeModal]);

  return (
    <Modal
      open={visible}
      handleClose={closeModal}
      className={classes.container}
      data-cy="removeItemsFromLocation"
      title={translate("deleteAddress")}
      dataCyTitle="editItemModalTitle"
      showActionButtons
      actionButtonProps={{
        textSave: translate("yes"),
        textCancel: translate("no"),
        dataCySave: "submitItemChange",
        onSave: onYesPress,
        onCancel: onNoPress,
      }}
    >
      <section>
        <h3 className={classes.message}>
          {translate("thereAreItemsOrMaterialsRegisteredWithThisAddressIfYouDeleteThisAddressNowAllItemsWillBeRegisteredWithTheMainDeliveryAddressWouldYouLikeToDoThat")}
        </h3>
      </section>
    </Modal>
  );
};

export default forwardRef(RemoveItemsFromLocationModal);
